import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "LocationPin",
  "use": "LocationPin-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"LocationPin\">\n  <path d=\"M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Z\">\n  </path>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol